"use client";

import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "@/lib/utils";

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-3", className)}
      {...props}
    />
  );
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      className={cn(
        "group relative aspect-square size-4 shrink-0 rounded-full border-1 outline-none transition-colors",
        // base idle
        "border-gray-500 bg-background ",
        // when checked, hide the border
        "data-[state=checked]:border-transparent data-[state=checked]:bg-primary-500 ",

        // focus & invalid
        "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ",
        "aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive/50",
        // disabled
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted disabled:border-muted",
        className
      )}
      {...props}
    >
      {/* === Hover dot for unchecked state === */}
      <span className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100">
        <span className="size-2 rounded-full bg-white" />
      </span>

      {/* === Checked indicator === */}
      <RadioGroupPrimitive.Indicator className="absolute inset-0 flex items-center justify-center rounded-full  ">
        <span className="size-2 rounded-full bg-white group-disabled:bg-muted-foreground" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
